define('modules/shell/widgets/datepicker/i18n/en',{
    "datepicker":{
        "clear":"Clear"
    }
});

